import Icon from '../Icon';

const AddedToPlanner = (props) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Icon {...props} viewBox="0 0 32 32">
      <path
        opacity="0.3"
        d="M1.82471 8.91255C1.82471 7.60778 2.88243 6.55005 4.18721 6.55005H23.0872C24.392 6.55005 25.4497 7.60778 25.4497 8.91255V28.6C25.4497 29.9048 24.392 30.9625 23.0872 30.9625H4.18721C2.88243 30.9625 1.82471 29.9048 1.82471 28.6V8.91255Z"
        fill="#5093F2"
      />
      <path
        d="M5.76221 4.97505C5.76221 3.67028 6.81993 2.61255 8.12471 2.61255H27.0247C28.3295 2.61255 29.3872 3.67028 29.3872 4.97505V24.6625C29.3872 25.9673 28.3295 27.025 27.0247 27.025H8.12471C6.81993 27.025 5.76221 25.9673 5.76221 24.6625V4.97505Z"
        fill="#5093F2"
      />
      <path
        d="M11.6685 1.89038C11.6685 1.34673 12.1092 0.906006 12.6528 0.906006C13.1965 0.906006 13.6372 1.34673 13.6372 1.89038V3.20288C13.6372 3.74654 13.1965 4.18726 12.6528 4.18726C12.1092 4.18726 11.6685 3.74654 11.6685 3.20288V1.89038Z"
        fill="#DCEAFC"
      />
      <path
        d="M21.5122 1.89038C21.5122 1.34673 21.9529 0.906006 22.4966 0.906006C23.0402 0.906006 23.481 1.34673 23.481 1.89038V3.20288C23.481 3.74654 23.0402 4.18726 22.4966 4.18726C21.9529 4.18726 21.5122 3.74654 21.5122 3.20288V1.89038Z"
        fill="#DCEAFC"
      />
      <path
        d="M17.2326 11.4848C17.3835 11.2189 17.7667 11.2189 17.9176 11.4848L19.3684 14.0421C19.4245 14.1409 19.5206 14.2107 19.6319 14.2335L22.5124 14.8232C22.8119 14.8845 22.9303 15.2489 22.724 15.4746L20.7403 17.6447C20.6636 17.7286 20.6269 17.8415 20.6396 17.9544L20.969 20.8761C21.0032 21.1799 20.6932 21.4051 20.4148 21.2787L17.738 20.0626C17.6345 20.0156 17.5157 20.0156 17.4122 20.0626L14.7354 21.2787C14.457 21.4051 14.147 21.1799 14.1812 20.8761L14.5106 17.9544C14.5233 17.8415 14.4866 17.7286 14.4099 17.6447L12.4262 15.4746C12.2199 15.2489 12.3383 14.8845 12.6378 14.8232L15.5182 14.2335C15.6296 14.2107 15.7257 14.1409 15.7818 14.0421L17.2326 11.4848Z"
        fill="white"
      />
      <path
        d="M8.9126 7.65255C8.9126 7.04365 9.4062 6.55005 10.0151 6.55005H25.9226C26.5315 6.55005 27.0251 7.04365 27.0251 7.65255C27.0251 8.26144 26.5315 8.75505 25.9226 8.75505H10.0151C9.4062 8.75505 8.9126 8.26144 8.9126 7.65255Z"
        fill="white"
      />
    </Icon>
  );
};

export default AddedToPlanner;
